import { EstadosLlamadaEnumChoice } from '@/shared';
import { ChipModelState } from '@/shared/components/ui';

export type EstadoLlamadaComponentProps = {
  estado: string;
};

const EstadoLlamadaComponent: React.FC<EstadoLlamadaComponentProps> = ({
  estado,
}) => {
  return (
    <>
      {estado === EstadosLlamadaEnumChoice.REALIZADA ? (
        <ChipModelState color="success" label="LLAMADA EXITOSA" />
      ) : estado === EstadosLlamadaEnumChoice.NO_CONTESTA ? (
        <ChipModelState color="warning" label="NO CONTESTA" />
      ) : estado === EstadosLlamadaEnumChoice.NO_REALIZADA ? (
        <ChipModelState color="error" label="NO REALIZADA" />
      ) : (
        'N/A'
      )}
    </>
  );
};

export default EstadoLlamadaComponent;
